export const DEFAULT_SIGNATURE_MODE_OPTIONS = [
  {
    label: 'label.VISUAL_PREVIEW',
    value: 'preview'
  },
  {
    label: 'label.PLAIN_TEXT',
    value: 'plain'
  }
];
